module.exports = __webpack_public_path__ + "static/media/family-and-relationships.f8c45c40.jpg";